import { BaseModel } from '../classes/base-model';

export class Entity extends BaseModel {
}



// WEBPACK FOOTER //
// ./src/app/models/entity.ts